import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cpfFormatter'
})
export class CpfFormatterPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) {
      return '';
    }

    // Remove qualquer caractere que não seja dígito
    let cpf = value.replace(/\D/g, '');

    // Formata o CPF: 123.456.789-10
    if (cpf.length === 11) {
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }

    // Se não tiver 11 dígitos, retorna o valor original
    return value;
  }

}
